/**
 * Recursively appends a plain object/array into a FormData using PHP/
 * Laravel's bracket-notation convention (field[key][nested]=value), so
 * nested settings (stats[], cta_primary{}) survive a multipart request
 * (needed whenever an editor mixes settings with a file upload) the same way
 * a plain JSON body would.
 */
export function appendNested(fd, key, value) {
  if (value === null || value === undefined) return;
  if (Array.isArray(value)) {
    value.forEach((v, i) => appendNested(fd, `${key}[${i}]`, v));
  } else if (typeof value === 'object') {
    Object.entries(value).forEach(([k, v]) => appendNested(fd, `${key}[${k}]`, v));
  } else {
    fd.append(key, value);
  }
}
